import React from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  FiGrid,
  FiBox,
  FiList,
  FiMapPin,
  FiMap,
  FiGlobe,
  FiStar,
  FiHeart,
  FiUsers,
  FiLogOut,
  FiCreditCard,
  FiFileText,
  FiHelpCircle,
  FiCalendar,
  FiBell,
  FiActivity,
} from 'react-icons/fi';
import { MdPets, MdLocalHospital } from 'react-icons/md';
import { logout } from '../../store/slices/authSlice';

const Sidebar = () => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  const navItems = [
    {
      section: 'Main',
      items: [
        { path: '/dashboard', icon: FiGrid, label: 'Dashboard' },
      ],
    },
    {
      section: 'Pet Management',
      items: [
        { path: '/pet-types', icon: FiBox, label: 'Pet Types' },
        { path: '/pet-breeds', icon: FiList, label: 'Pet Breeds' },
        { path: '/features', icon: FiStar, label: 'Features' },
        { path: '/pets', icon: FiHeart, label: 'All Pets' },
      ],
    },
    {
      section: 'Location',
      items: [
        { path: '/countries', icon: FiGlobe, label: 'Countries' },
        { path: '/states', icon: FiMap, label: 'States' },
        { path: '/cities', icon: FiMapPin, label: 'Cities' },
      ],
    },
    {
      section: 'Users',
      items: [
        { path: '/users', icon: FiUsers, label: 'Users' },
        { path: '/subscriptions', icon: FiCreditCard, label: 'Subscriptions' },
        // { path: '/payment-test', icon: FiActivity, label: '💳 Payment Test' },
        { path: '/notifications', icon: FiBell, label: 'Notifications' },
      ],
    },
    {
      section: 'Doctors',
      items: [
        { path: '/doctors', icon: MdLocalHospital, label: 'Doctors' },
        { path: '/appointments', icon: FiCalendar, label: 'Appointments' },
      ],
    },
    {
      section: 'Content & Support',
      items: [
        { path: '/cms-pages', icon: FiFileText, label: 'CMS Pages' },
        { path: '/help-support', icon: FiHelpCircle, label: 'Help & Support' },
      ],
    },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">
            <MdPets />
          </div>
          <span className="sidebar-logo-text">Pet Admin</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((section, index) => (
          <div className="nav-section" key={index}>
            <span className="nav-section-title">{section.section}</span>
            {section.items.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `nav-item ${isActive ? 'active' : ''}`
                }
              >
                <span className="nav-item-icon">
                  <item.icon />
                </span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <button className="logout-btn" onClick={handleLogout}>
        <FiLogOut />
        <span>Logout</span>
      </button>
    </aside>
  );
};

export default Sidebar;
